export function formatingPrice (val, minimumFractionDigits) {
    return new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: minimumFractionDigits,
    }).format(val)
}

export function isInteger(x) { return typeof x === "number" && isFinite(x) && Math.floor(x) === x; }
